// extracted by mini-css-extract-plugin
export default {"selectedPanel":"ChooseTestQuestions_selectedPanel__bRB1p","selectedCard":"ChooseTestQuestions_selectedCard__hFCPx","emptyCard":"ChooseTestQuestions_emptyCard__mX4pe"};